




























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import VipTag from '@/api/vip/vipTag/index'
import BrandApi from '@/api/goods/brand'
import GoodsApi from '@/api/goods/list'

interface formValidate {
  Brands: any[]
  CategoryId: string[]
}

@Component
export default class GoodListConfig extends Vue {
  @Prop({
    type: Boolean,
    default: () => {
      return false
    }
  })
  show!: false

  @Prop({
    type: Boolean,
    default: () => {
      return true
    }
  })
  showBrands!: true

  showModal = false
  categoryOptions: any[] = []
  brandOptions: any[] = []

  formValidate: formValidate = {
    Brands: [],
    CategoryId: []
  }
  ruleValidate: any = {
    Brands: [
      {
        required: false,
        type: 'array',
        message: '请选择品牌',
        trigger: 'change'
      }
    ],
    CategoryId: [
      {
        required: false,
        type: 'array',
        message: '请选择商品分类',
        trigger: 'change'
      }
    ]
  }

  async mounted() {}

  @Watch('show')
  async modalShowChange(show) {
    this.showModal = !this.showModal
    if (this.showModal) {
      await this.getCategoriesAll()
      if (this.showBrands) {
        await this.getGoodsBrand()
      }
    }
  }

  resetData() {
    this.showModal = false
    this.formValidate = {
      Brands: [],
      CategoryId: []
    }
  }

  cancelFn() {
    this.resetData()
    if (this.showBrands) {
      this.$emit('on-cancel', this.formValidate)
    } else {
      this.$emit('on-cancel', {
        CategoryId: this.formValidate.CategoryId
      })
    }
  }

  ok() {
    if (this.showBrands) {
      this.$emit('on-cancel', this.formValidate)
    } else {
      this.$emit('on-cancel', {
        CategoryId: this.formValidate.CategoryId
      })
    }
    this.resetData()
  }

  async getCategoriesAll() {
    await GoodsApi.getCategoriesAll().then(res => {
      if (res.data.items) {
        this.categoryOptions = res.data.items
      }
    })
  }

  async getGoodsBrand() {
    await BrandApi.getAll().then(res => {
      this.brandOptions = res.data.items
    })
  }
}
